module.exports = require('./helpers/bundle-url').getBundleURL('dg7cp') + "logo-dark.eefe0b7f.svg";